import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]

  connect() {
    // Initial state setup - ensure password fields match checkbox state
    this.togglePasswordFields({ target: this.element })
  }

  togglePasswordFields(event) {
    const isChecked = event.target.checked
    
    this.fieldTargets.forEach(field => {
      // Find the password input within the field div
      const input = field.querySelector('input[type="password"]')
      
      if (input) {
        // Toggle disabled state
        input.disabled = !isChecked
        
        // If unchecked, clear any input values
        if (!isChecked) {
          input.value = ""
        }
      }
    })
  }
}